import { Box, Button, Chip, FormControl, FormControlLabel, IconButton, InputLabel, LinearProgress, MenuItem, Modal, Paper, Select, Stack, styled, Switch, TextField, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import '../styles.scss'
import Grid from "@mui/material/Grid2";
import { useEffect, useState } from 'react';
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { IUpdateDiagnosticForActivity, UpdateDiagnosticForActivity } from 'src/shared/util/updateDataServer';
import { useDispatch, useSelector } from "src/stateManagement/redux";
import Swal from "sweetalert2";
import { useParams } from 'react-router-dom';
import { createLocationTag, deletedFile, deleteLocationTag, loadLocationDetails } from 'src/stateManagement/redux/slices/location/asyncReducers';
import { DynSort } from '../sort_dyn';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { generateDiagnostic } from 'src/tecnica/utils/generateDiagnostic';
import { getLocations } from 'src/stateManagement/redux/slices/gerencia_tecnica/asyncReducers';
import { ModalVariables } from '../modalVariables';
import { OptimizationActivities } from './modalDiagnosticOptimization';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import PublishIcon from '@mui/icons-material/Publish';
import { Requerimientos } from '../../../requerimientos/requerimientos';
import { selectMainState } from "../../../../../../../../../stateManagement/redux";
import WarningIcon from '@mui/icons-material/Warning';
import moment from 'moment';
import SubSurfaceJobs from '../../../tendencias/components/subSurfaceJob';
import WaterTest from '../../../tendencias/components/waterTest';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { FileAttachment } from '../../../files/fileattachment';
import { formatDate } from 'src/shared/util/functions';
import VrpanoIcon from '@mui/icons-material/Vrpano';
import { FilePreviewModal } from '../../../files/fileDetaile';
import HighlightOffTwoToneIcon from "@mui/icons-material/HighlightOffTwoTone";
import { SteamModule } from '../../../steam';
import { ProductionModule } from '../../../production';
import AddIcon from '@mui/icons-material/Add';
import { QuickAddOptimizationModal } from './quick_add_optimization/QuickAddOptimizationModal';
import { QuickAddRequirementModal } from './quick_add_optimization/QuickAddRequirementModal';
import { normalizeText } from "src/shared/util/normalizeText";
import AddBoxIcon from '@mui/icons-material/AddBox';

const status_candidato_listy = [
    { id: "Reevaluación", name: "Reevaluación" },
    { id: "Oportunidad de Incremento", name: "Oportunidad de Incremento" },
    { id: "Mantener Condiciones", name: "Mantener Condiciones" }
]

// const condicion_fondo_list = [
//     { id: "Golpe de Fluido", name: "Golpe de Fluido" },
//     { id: "Inteferencia por Gas", name: "Inteferencia por Gas" },
//     { id: "Pendiente por Determinar", name: "Pendiente por Determinar" },
//     { id: "Buenas Condiciones", name: "Buenas Condiciones" },
//     { id: "Golpe de Bomba", name: "Golpe de Bomba" },
//     { id: "Baja Accion de Bombeo", name: "Baja Accion de Bombeo" },
//     { id: "Fuga en Valvula Viajera", name: "Fuga en Valvula Viajera" },
//     { id: "Fuga en Valvula Fija", name: "Fuga en Valvula Fija" },
//     { id: "Cierre Tardio de Valvula Fija", name: "Cierre Tardio de Valvula Fija" },
//     { id: "Cierra Tardio de Valvula Viajera", name: "Cierra Tardio de Valvula Viajera" },
//     { id: "Mal Funcionamiento de Ambas Valvulas", name: "Mal Funcionamiento de Ambas Valvulas" },
//     { id: "Bomba Deficiente", name: "Bomba Deficiente" },
//     { id: "Cabilla Desconectada", name: "Cabilla Desconectada" },
//     { id: "Tuberia Rota", name: "Tuberia Rota" },
//     { id: "Sin Accion de Bombeo", name: "Sin Accion de Bombeo" },
//     { id: "Flumping", name: "Flumping" }
// ];

const taskStates = [
    { id: "pending", name: "Por Analizar" },
    { id: "analyzing", name: "Evaluar Luego" },
    { id: "finished", name: "Analizada" }
];

const WELL_DIAGNOSTIC_TAGS = [
    {
        tagId: "0f7d23b0-342c-11f0-bbe6-00505652cca1",
        label: "Pozo repetitivo TDS",
        removeConfirmText:
            "Quieres Desmarcar el pozo como repetitivo con multiples entradas TDS ?",
    },
    // {
    //     tagId: "3a0c67fd-a2ee-11f0-b43d-00505652cca1",
    //     label: "Pozo IAV",
    //     removeConfirmText: "¿Quieres quitar la etiqueta Pozo IAV de esta ubicación?",
    // },
    {
        tagId: "e5af4710-2abd-11f1-aec6-a2aad9513213",
        label: "Pozo identificado TDS",
        removeConfirmText:
            "¿Quieres quitar la etiqueta Pozo identificado TDS de esta ubicación?",
    },
] as const;


export const ModalDiagnostic = ({ open, onClose, sortDyns, activeDyn, listSortDyns }: { open: any, onClose: any, sortDyns: any, activeDyn: any, listSortDyns: DynSort[] }) => {

    const [loading, setloading] = useState(false)

    const { configModules } = useSelector(selectMainState);

    const { id } = useParams();

    const dispatch = useDispatch();

    const { projectId, locationId, locationTags, loading: locationLoading, optimizationRequirements, requirements } = useSelector((state) => state.location);

    const { productionTests } = useSelector((state) => state.location);

    const { waterTests } = useSelector((state) => state.location);

    const { activeUser } = useSelector((state) => state.main);

    const [showVariables, setShowVariables] = useState("diagnostic")

    const [activeDiagnostic, setActiveDiagnostic] = useState<IUpdateDiagnosticForActivity>()

    const [condicionFondoList, setCondicionFondoList] = useState<any[]>([])

    const [isWellWithMultiplesTDSEntries, setIsWellWithMultiplesTDSEntries] = useState(false)

    const [subSurfaceDataTable, setSubSurfaceDataTable] = useState<any[]>([]);

    const [showFileId, setShowFileId] = useState<string | null>(null);

    const [lastProductionTest, setProductionTest] = useState<any>(undefined)

    const [lastWaterTest, setLastWaterTest] = useState<any>(undefined)

    const [averageWaterTestsLast5, setAverageWaterTestsLast5] = useState<{
        average: number;
        standardDeviation: number;
        startDate: string;
        endDate: string;
    } | undefined>(undefined)

    const [showQuickAddOptimization, setShowQuickAddOptimization] = useState(false)
    const [showQuickAddRequirement, setShowQuickAddRequirement] = useState(false)
    
    useEffect(() => {

        if (productionTests?.length === 0) return

        const sortProductionTests = [...productionTests].sort((a, b) => new Date(b.testDate).getTime() - new Date(a.testDate).getTime());

        if (sortProductionTests.length === 0) return

        const lastProductionTest = sortProductionTests[0]

        setProductionTest(lastProductionTest)

    }, [productionTests])
    

    useEffect(() => {
        if (waterTests?.length === 0) return

        const sortWaterTests = [...waterTests].sort((a, b) => new Date(b.samplingDate).getTime() - new Date(a.samplingDate).getTime());

        if (sortWaterTests.length === 0) return

        const lastWaterTest = sortWaterTests[0]

        setLastWaterTest(lastWaterTest)

        // Calcular promedio de las últimas 5 muestras anteriores a la actual (excluyendo la última)
        if (sortWaterTests.length > 1) {
            // Tomar las últimas 5 muestras anteriores (índices 1-5, excluyendo la 0)
            const previous5Tests = sortWaterTests.slice(1, 6);

            if (previous5Tests.length > 0) {
                // Calcular promedio de totalWaterPercentage
                const totalWaterValues = previous5Tests
                    .map(test => parseFloat(test.totalWaterPercentage))
                    .filter(value => !isNaN(value));

                if (totalWaterValues.length > 0) {
                    const average = totalWaterValues.reduce((sum, val) => sum + val, 0) / totalWaterValues.length;
                    
                    // Calcular desviación estándar
                    const variance = totalWaterValues.reduce((sum, val) => sum + Math.pow(val - average, 2), 0) / totalWaterValues.length;
                    const standardDeviation = Math.sqrt(variance);
                    
                    // Obtener fechas de inicio y fin (la más antigua y la más reciente de las 5)
                    const dates = previous5Tests
                        .map(test => test.samplingDate)
                        .filter(date => date)
                        .map(date => new Date(date))
                        .sort((a, b) => a.getTime() - b.getTime());
                    
                    if (dates.length > 0) {
                        const startDate = dates[0];
                        const endDate = dates[dates.length - 1];
                        
                        setAverageWaterTestsLast5({
                            average,
                            standardDeviation,
                            startDate: moment(startDate).format("DD-MMM-YY"),
                            endDate: moment(endDate).format("DD-MMM-YY")
                        });
                    } else {
                        setAverageWaterTestsLast5(undefined);
                    }
                } else {
                    setAverageWaterTestsLast5(undefined);
                }
            } else {
                setAverageWaterTestsLast5(undefined);
            }
        } else {
            setAverageWaterTestsLast5(undefined);
        }
        
    }, [waterTests])

    useEffect(() => {
        if (locationLoading) {
            setloading(true)
        } else {
            setloading(false)
        }
    }, [locationLoading])


    useEffect(() => {

        if (Array.isArray(configModules?.bottomHoleConditions)) {

            const copiaOrdenada = [...configModules?.bottomHoleConditions].sort(
                (a, b) =>
                    a.name.localeCompare(b.name, "es", { sensitivity: "base" })
            );

            const candidateState = activeDiagnostic?.candidateSate || ""
            const currentBh = activeDiagnostic?.bottomHoleCondition || ""

            const filteredCopiaOrdenada = copiaOrdenada.filter((cond: any) => {
                const enabledOn = cond?.enabledOn
                const hasRestriction =
                    Array.isArray(enabledOn) && enabledOn.length > 0
                const allowedByCandidate =
                    !hasRestriction ||
                    enabledOn.includes(candidateState)
                const isCurrentValue =
                    cond.id === currentBh ||
                    cond.name === currentBh
                return allowedByCandidate || isCurrentValue
            })

            setCondicionFondoList(filteredCopiaOrdenada);
        }

    }, [configModules, activeDiagnostic?.candidateSate, activeDiagnostic?.bottomHoleCondition])

    useEffect(() => {

        if (!sortDyns || !activeDyn || !listSortDyns) return

        const originFieldActivityIds = listSortDyns?.map((dyn) => dyn.fieldActivityId)

        const mpt = activeDyn?.mpt

        const ept = activeDyn?.ept

        const dplunger = sortDyns?.dpluger

        const fillage = ept / mpt * 100

        const newActiveDiagnostic: IUpdateDiagnosticForActivity = {
            originFieldActivityIds,
            projectId: projectId,
            locationId: locationId,
            diagnostic: activeDiagnostic?.diagnostic || sortDyns?.diagnostic || '',
            recommendation: activeDiagnostic?.recommendation || sortDyns?.recommendations || '',
            candidateSate: activeDiagnostic?.candidateSate || sortDyns?.candidateSate || '',
            bottomHoleCondition: activeDiagnostic?.bottomHoleCondition || sortDyns?.bottomHoleConditions || '',
            subBottomHoleCondition: activeDiagnostic?.subBottomHoleCondition || sortDyns?.subBottomHoleConditions || '',
            bottomHoleFillage: fillage,
            requiredUserId: activeUser?.id || '',
            executedAt: new Date(),
            ept,
            theoricalProduction: sortDyns?.bbpd || 0,
            pumpEfficiency: sortDyns?.pumpEfficiency,
            adjustProduction: sortDyns?.adjustProduction || 0,
            mpt,
            dplunger,
            newFieldActivityState: activeDiagnostic?.newFieldActivityState || 'finished',
            optimizationActivitiesSelected: activeDiagnostic?.optimizationActivitiesSelected || sortDyns?.optimizationActivitiesSelected || [],
            analyzedBy: sortDyns?.analyzedBy,
            analyzedDate: sortDyns?.analyzedDate,
            includeAttachments: false,
            attachedFiles: sortDyns?.attachedFiles || [],
            runLife: sortDyns?.runLife || 0,
            lastSubSurfaceJobFinishedDate: sortDyns?.lastSubSurfaceJobFinishedDate || '',
            daysAfterSteamInjection: sortDyns?.daysAfterSteamInjection || 0,
            lastLocationEventHistoryChangeDate: sortDyns?.lastLocationEventHistoryChangeDate || '',
            cicleCount: sortDyns?.cicleCount || 0,
        }


        setActiveDiagnostic(newActiveDiagnostic)
    }, [sortDyns, activeDyn, listSortDyns, open])

    useEffect(() => {
        const isWellWithMultiplesTDSEntries = locationTags?.some((tag) => tag.tagId === "0f7d23b0-342c-11f0-bbe6-00505652cca1");

        setIsWellWithMultiplesTDSEntries(isWellWithMultiplesTDSEntries)

        if (isWellWithMultiplesTDSEntries && activeDiagnostic) {
            const newActiveDiagnostic = { ...activeDiagnostic, isWellWithMultiplesTDSEntries: true }
            setActiveDiagnostic(newActiveDiagnostic)
        }

    }, [locationTags])


    const validateDiagnostic = () => {
        const fieldsToValidate = [
            { field: 'diagnostic', message: "El campo diagnóstico es requerido" },
            { field: 'recommendation', message: "El campo recomendación es requerido" },
            { field: 'candidateSate', message: "El campo estado candidato es requerido" },
            { field: 'bottomHoleCondition', message: "El campo condición de fondo es requerido" }]

        const messageErros: string[] = []

        if (!activeDiagnostic) return messageErros

        const diagnosticTovalidate: any = { ...activeDiagnostic }

        fieldsToValidate.forEach((f) => {
            if (!diagnosticTovalidate[f.field] || diagnosticTovalidate[f.field].trim() === "") {
                messageErros.push(f.message)
            }
        }
        )

        if (!(diagnosticTovalidate?.optimizationActivitiesSelected?.length > 0)) {
            messageErros.push("Debe seleccionar al menos una opcion de optimizacion")
        }

        return messageErros
    }

    const onSaveDiagnostic = () => {
        if (activeDiagnostic) {

            const errors = validateDiagnostic()

            if (errors.length > 0) {
                Swal.fire({
                    title: "Error!",
                    icon: "error",
                    html: `<p>No se puede proceder debido a los siguientes errores:</p><ul>${errors.map(error => `<li>${error}</li>`).join('')}</ul>`

                });
                return
            }

            setloading(true)
            UpdateDiagnosticForActivity(activeDiagnostic).then((data) => {
                setloading(false)
                Swal.fire({
                    title: "Guardado!",
                    icon: "success",
                });
                dispatch(loadLocationDetails(id!));
                dispatch(getLocations(true));
            }
            ).catch((error) => {
                Swal.fire({
                    title: "Error!",
                    icon: "error",
                });
                console.log(error)
                setloading(false)
            })
        }
    }


    const handleClose = () => {
        if (loading) return
        onClose()
    }

    const generateSimpleDiagnostic = () => {
        const diagnostic = generateDiagnostic(activeDyn, activeDiagnostic, sortDyns)
        handleOnChangeValue(diagnostic, "diagnostic")
    }

    const handleOnChangeValue = (value: any, label: any) => {
        const newActiveDiagnostic: any = { ...activeDiagnostic }
        newActiveDiagnostic[label] = value

        if (label === "bottomHoleCondition") {


            let subBottomHoleCondition = ""

            const bottomHoleCondition = condicionFondoList.find((cond) => cond.id === value)

            switch (value) {
                case "Golpe de Fluido":
                    if ((activeDiagnostic?.bottomHoleFillage || 0) < 20) {
                        subBottomHoleCondition = "Golpe de Fluido Critico (<20%)"
                    } else if ((activeDiagnostic?.bottomHoleFillage || 0) < 50) {
                        subBottomHoleCondition = "Golpe de Fluido Llenado Medio (20% al 50%)"
                    } else {
                        subBottomHoleCondition = "Golpe de Fluido Buen Llenado (50% al 90%)"
                    }

                    break;
                case "Inteferencia por Gas":
                    if ((activeDiagnostic?.bottomHoleFillage || 0) < 20) {
                        subBottomHoleCondition = "Interferencia por Gas Critico (<20%)"
                    } else if ((activeDiagnostic?.bottomHoleFillage || 0) < 50) {
                        subBottomHoleCondition = "Interferencia por Gas Llenado Medio (20% al 50%)"
                    } else {
                        subBottomHoleCondition = "Interferencia por Gas Buen Llenado (50% al 90%)"
                    }

                    break;

                default:
                    if (bottomHoleCondition?.isDeficient) {
                        subBottomHoleCondition = "Deficiente";
                    } else {
                        subBottomHoleCondition = value;
                    }
                    break;

            }

            newActiveDiagnostic["subBottomHoleCondition"] = subBottomHoleCondition
        }

        setActiveDiagnostic(newActiveDiagnostic)
    }

    const addRemoveOptimizationActivity = (activity: any, add: boolean) => {
        if (!activeDiagnostic) return

        let id = activity?.activity ? `${activity.optimizationActivityId}-${activity.activity}` : activity?.id

        const optimizationActivities = activeDiagnostic.optimizationActivitiesSelected || []
        const filteredActivities = optimizationActivities.filter((opt) => opt.id !== id)
        const newOptimizationActivitiesSelected = [...filteredActivities]
        if (add) {

            newOptimizationActivitiesSelected.push({
                id: id,
                name: activity.activity,
                simulated: activity?.simulated || false,
                optimizationActivityId: activity.optimizationActivityId,
                main: activity?.main || false,
                isWellWithMultiplesTDSEntries: activity?.isWellWithMultiplesTDSEntries || false
            })
        }

        setActiveDiagnostic({
            ...activeDiagnostic,
            optimizationActivitiesSelected: newOptimizationActivitiesSelected
        })
    }

    const handleConvertToMain = (activity: any) => {
        if (!activeDiagnostic) return

        let id = activity?.activity ? `${activity.optimizationActivityId}-${activity.activity}` : activity?.id

        const optimizationActivities = activeDiagnostic.optimizationActivitiesSelected || []

        const newOptimizationActivitiesSelected = optimizationActivities.map((opt) => {
            if (opt.id === id) {
                return { ...opt, main: true }
            } else {
                return { ...opt, main: false }
            }
        })

        // Sort to have the main activity first
        newOptimizationActivitiesSelected.sort((a, b) => (b.main ? 1 : 0) - (a.main ? 1 : 0));

        setActiveDiagnostic({
            ...activeDiagnostic,
            optimizationActivitiesSelected: newOptimizationActivitiesSelected
        })
    }

    const [pendingActivityData, setPendingActivityData] = useState<{ types: string[], simulationDate?: string, isWellWithMultiplesTDSEntries: boolean, existingActivities?: any[] } | null>(null);

    // useEffect para auto-seleccionar la actividad cuando se actualice el estado
    useEffect(() => {
        if (!pendingActivityData || !activeDiagnostic) return;

        // Si hay actividades existentes, agregarlas directamente
        if (pendingActivityData.existingActivities && pendingActivityData.existingActivities.length > 0) {
            pendingActivityData.existingActivities.forEach((existingActivity) => {
                addRemoveOptimizationActivity(existingActivity, true);
            });
            setPendingActivityData(null);
            return;
        }

        const originFieldActivityId = activeDiagnostic?.originFieldActivityIds[0];
        if (!originFieldActivityId || !pendingActivityData.types || pendingActivityData.types.length === 0) {
            setPendingActivityData(null);
            return;
        }

        // Buscar la actividad recién creada (puede ser Optimization o Requirement)
        // Combinar ambos arrays para buscar
        const allRequirements = [
            ...(optimizationRequirements || []),
            ...(requirements || [])
        ];

        const createdRequirement = allRequirements
            .filter((req: any) => 
                req.originFieldActivityId === originFieldActivityId &&
                pendingActivityData.types.some((type: string) => 
                    normalizeText(req.activity) === normalizeText(type)
                )
            )
            .sort((a: any, b: any) => 
                new Date(b.requiredDate).getTime() - new Date(a.requiredDate).getTime()
            )[0];

        if (createdRequirement) {
            // Construir el objeto de actividad para auto-seleccionar
            const activityToSelect = {
                optimizationActivityId: createdRequirement.optimizationActivityId,
                activity: pendingActivityData.types[0],
                simulated: !!pendingActivityData.simulationDate,
                isWellWithMultiplesTDSEntries: pendingActivityData.isWellWithMultiplesTDSEntries,
            };

            // Auto-seleccionar la actividad creada
            addRemoveOptimizationActivity(activityToSelect, true);
            setPendingActivityData(null);
        }
    }, [optimizationRequirements, requirements, pendingActivityData, activeDiagnostic]);

    const handleActivityCreated = (activityData: { types: string[], simulationDate?: string, isWellWithMultiplesTDSEntries: boolean, existingActivities?: any[] }) => {
        // Si hay actividades existentes, agregarlas inmediatamente
        if (activityData.existingActivities && activityData.existingActivities.length > 0) {
            activityData.existingActivities.forEach((existingActivity) => {
                addRemoveOptimizationActivity(existingActivity, true);
            });
        }

        // Si solo hay actividades existentes (sin nuevas), no necesitamos esperar
        if ((!activityData.types || activityData.types.length === 0)) {
            return;
        }

        // Guardar los datos para que el useEffect los procese cuando se actualice el estado (para actividades nuevas)
        setPendingActivityData(activityData);
    }

    const handleRequirementCreated = (requirementData: { types: string[], existingRequirements?: any[] }) => {
        // Si hay requerimientos existentes, agregarlos inmediatamente
        if (requirementData.existingRequirements && requirementData.existingRequirements.length > 0) {
            requirementData.existingRequirements.forEach((existingRequirement) => {
                addRemoveOptimizationActivity(existingRequirement, true);
            });
        }

        // Si solo hay requerimientos existentes (sin nuevos), no necesitamos esperar
        if ((!requirementData.types || requirementData.types.length === 0)) {
            return;
        }

        // Guardar los datos para que el useEffect los procese cuando se actualice el estado (para requerimientos nuevos)
        setPendingActivityData({
            types: requirementData.types,
            simulationDate: undefined,
            isWellWithMultiplesTDSEntries: false,
        });
    }

    const handleWellTagToggle = (
        tagId: string,
        enabled: boolean,
        removeConfirmText: string
    ) => {
        if (enabled) {
            const comment = `Agregado a la actividad ejecutada por campo el dia ${new Date(sortDyns.executedDate || "").toLocaleDateString()}, analizada por ${activeDiagnostic?.analyzedBy} el ${new Date(activeDiagnostic?.analyzedDate || "").toLocaleDateString()}`;

            dispatch(
                createLocationTag({
                    locationId,
                    tagId,
                    comment,
                })
            );
        } else {
            const tagToRemove = locationTags?.find((tag) => tag.tagId === tagId);
            if (tagToRemove) {
                const data = { id: tagToRemove.id };

                Swal.fire({
                    title: "Estas seguro?",
                    text: removeConfirmText,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "SI, eliminar!",
                }).then((result) => {
                    if (result.isConfirmed) {
                        dispatch(deleteLocationTag(data, locationId));
                        Swal.fire({
                            title: "Eliminado!",
                            icon: "success",
                        });
                    }
                });
            }
        }
    };


    const handleAddRemoveAttachment = (row: any) => {

        const existFile = activeDiagnostic?.attachedFiles.find(file => file.id === row.id);
        const otherAttachments = activeDiagnostic?.attachedFiles.filter(file => file.id !== row.id) || [];

        if (existFile && activeDiagnostic) {
            setActiveDiagnostic({
                ...activeDiagnostic,
                attachedFiles: otherAttachments
            })
        } else {
            setActiveDiagnostic({
                ...activeDiagnostic!,
                attachedFiles: [...(activeDiagnostic?.attachedFiles || []), row]
            })
        }
    }

    const handleShowFileModal = (fileId: string) => {
        setShowFileId(fileId);
    }

    const formatLabel = (label: string) => {
        const excepciones = ["de", "y"];
        let resultado = "";
        let capitalizarSiguiente = true;

        for (let i = 0; i < label.length; i++) {
            const char = label[i];

            if (char === " ") {
                resultado += char;
                capitalizarSiguiente = true;
                continue;
            }

            if (capitalizarSiguiente) {
                const palabraRestante = label.slice(i).split(" ")[0];
                const esExcepcion = excepciones.includes(palabraRestante.toLowerCase());

                if (esExcepcion) {
                    resultado += palabraRestante.toLowerCase();
                    i += palabraRestante.length - 1;
                    capitalizarSiguiente = false;
                } else {
                    resultado += char.toUpperCase();
                    capitalizarSiguiente = false;
                }
            } else {
                resultado += char.toLowerCase();
            }
        }

        return resultado;
    }

    const filterTypeOfActivity = (activities: any[], typeOfActivity: "Requirement" | "Optimization"): any[] => {
        const requiredActivities = configModules?.typesActivitiesForRequirements?.map((activity: any) => activity.label)||[];
        const optimizationActivities = configModules?.typesActivitiesForOptimization?.map((activity: any) => activity.label)||[];

        if (typeOfActivity === "Requirement") { 
            return activities.filter(activity => requiredActivities.includes(activity.name));
        } else if (typeOfActivity === "Optimization") {
            return activities.filter(activity => optimizationActivities.includes(activity.name));
        }
        return [];       
    }



    return (
        <>
            <Modal open={open} onClose={handleClose}>
                <Box>
                    {showFileId && (
                        <FilePreviewModal
                            id={showFileId}
                            open={!!showFileId}
                            onClose={() => setShowFileId(null)}
                        />
                    )}

                <Box className="modal_update_card_location">
                    {/* headers */}
                    <Box className="modal_header">
                        <Grid className="header_title_container">
                            <IconButton
                                aria-label="delete"
                                size="small"
                                onClick={handleClose}
                            >
                                <HighlightOffTwoToneIcon
                                    sx={{ color: "#b15050" }}
                                />
                            </IconButton>
                            <Typography
                                className="title"
                                id="modal-modal-title"
                                variant="h6"
                                component="h2"
                            >
                                Agregar Diagnóstico
                            </Typography>
                            {showVariables === "diagnostic" && (
                                <IconButton
                                    aria-label="delete"
                                    size="small"
                                    onClick={() => onSaveDiagnostic()}
                                >
                                    <SaveOutlinedIcon color="primary" />
                                </IconButton>
                            )}
                        </Grid>
                        <Grid size={12} className="header_tabs">
                            <Grid
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        mb: 1,
                                    }}
                                >
                                    <ToggleButtonGroup
                                        value={showVariables}
                                        exclusive
                                        onChange={(_event, value) =>
                                            setShowVariables(value)
                                        }
                                        aria-label="Secciones"
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                            backgroundColor: "#fff",
                                            px: 2,
                                            py: 1,
                                            borderRadius: 1,
                                        }}
                                    >
                                        {[
                                            {
                                                value: "variables",
                                                label: "Variables",
                                            },
                                            {
                                                value: "diagnostic",
                                                label: "Diagnóstico",
                                            },
                                            {
                                                value: "optimizationOptions",
                                                label: "Opciones Optimización",
                                            },
                                            {
                                                value: "requirements",
                                                label: "Requerimientos",
                                            },
                                            {
                                                value: "trabajosSubsuelo",
                                                label: "Trabajos de Subsuelo",
                                            },
                                            {
                                                value: "muestrasAyS",
                                                label: "Muestras de AyS",
                                            },
                                            {
                                                value: "steamInjection",
                                                label: "Ciclos de Vapor",
                                            },
                                            {
                                                value: "productionTest",
                                                label: "Producción",
                                            },
                                        ].map((tab, index, arr) => (
                                            <Box
                                                key={tab.value}
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <ToggleButton
                                                    value={tab.value}
                                                    sx={{
                                                        border: "none",
                                                        fontSize: "14px",
                                                        color: "#444",
                                                        fontWeight:
                                                            showVariables ===
                                                                tab.value
                                                                ? 700
                                                                : 700,
                                                        px: 1,
                                                        "&.Mui-selected": {
                                                            color: "custom.icons",
                                                            fontWeight: 500,
                                                            backgroundColor:
                                                                "transparent",
                                                        },
                                                        "&:hover": {
                                                            backgroundColor:
                                                                "transparent",
                                                        },
                                                        textTransform: "none",
                                                    }}
                                                >
                                                    {formatLabel(tab.label)}
                                                </ToggleButton>
                                                {index < arr.length - 1 && (
                                                    <Box
                                                        component="span"
                                                        sx={{
                                                            mx: 1,
                                                            color: "#888",
                                                            fontWeight: 300,
                                                        }}
                                                    >
                                                        |
                                                    </Box>
                                                )}
                                            </Box>
                                        ))}

                                        <ToggleButton
                                            value="filesManager"
                                            sx={{
                                                border: "none",
                                                px: 1,
                                                color:
                                                    showVariables ===
                                                        "filesManager"
                                                        ? "primary.main"
                                                        : "#444",
                                                "&.Mui-selected": {
                                                    backgroundColor:
                                                        "transparent",
                                                },
                                            }}
                                        >
                                            <AttachFileIcon fontSize="small" />
                                        </ToggleButton>
                                    </ToggleButtonGroup>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                    {loading && (
                        <>
                            <Box className="modal_analyst_loading_background" />
                            <Box className="modal__analyst_task_loading">
                                <LinearProgress />
                                Saving....
                            </Box>
                        </>
                    )}
                    <Grid container spacing={1} sx={{ padding: "0px 30px" }}>
                        {showVariables === "diagnostic" && (
                            <>
                                <Grid size={12} className="analyzed_by" sx={{
                                    justifyContent: activeDiagnostic?.analyzedBy ? "space-between" : "flex-end"
                                }}>
                                    {activeDiagnostic?.analyzedBy && (
                                        <>
                                            <Grid className="analyzed_by_text">
                                                <Typography className="subtitle2">
                                                    Analizado por:{" "}
                                                    {activeDiagnostic?.analyzedBy}{" "}
                                                    el{" "}
                                                    {moment(
                                                        activeDiagnostic?.analyzedDate ||
                                                        ""
                                                    ).format("DD/MM/YYYY")}
                                                </Typography>
                                            </Grid>
                                        </>
                                    )}
                                    {showVariables === "diagnostic" && (
                                        <IconButton
                                            size="small"
                                            onClick={() =>
                                                generateSimpleDiagnostic()
                                            }
                                            sx={{
                                                marginTop: 1
                                            }}
                                        >
                                            <AutoAwesomeIcon color="primary" />
                                        </IconButton>
                                    )}
                                </Grid>
                                {/* Diagnostico */}
                                <Grid size={12}>
                                    <Paper elevation={3}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                padding: 2,
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            <Typography className="label-input">
                                                DIAGNÓSTICO
                                            </Typography>
                                            <TextField
                                                id="variable"
                                                size="small"
                                                value={
                                                    activeDiagnostic?.diagnostic ||
                                                    ""
                                                }
                                                onChange={(e) =>
                                                    handleOnChangeValue(
                                                        e.target.value,
                                                        "diagnostic"
                                                    )
                                                }
                                                fullWidth
                                                error={
                                                    !activeDiagnostic?.diagnostic ||
                                                    activeDiagnostic?.diagnostic.trim() ===
                                                    ""
                                                }
                                                multiline
                                                rows={3}
                                                sx={{
                                                    "& .MuiOutlinedInput-root":
                                                    {
                                                        "& fieldset": {
                                                            border: "none",
                                                        },
                                                    },
                                                    marginTop: "-10px",
                                                }}
                                            />
                                        </Box>
                                    </Paper>
                                </Grid>
                                {/* Recomendacion */}
                                <Grid size={12}>
                                    <Paper elevation={3}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                padding: 2,
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            <Typography className="label-input">
                                                RECOMENDACIÓN
                                            </Typography>
                                            <TextField
                                                id="variable"
                                                size="small"
                                                onChange={(e) =>
                                                    handleOnChangeValue(
                                                        e.target.value,
                                                        "recommendation"
                                                    )
                                                }
                                                value={
                                                    activeDiagnostic?.recommendation ||
                                                    ""
                                                }
                                                error={
                                                    !activeDiagnostic?.recommendation ||
                                                    activeDiagnostic?.recommendation.trim() ===
                                                    ""
                                                }
                                                fullWidth
                                                multiline
                                                rows={3}
                                                sx={{
                                                    "& .MuiOutlinedInput-root":
                                                    {
                                                        "& fieldset": {
                                                            border: "none",
                                                        },
                                                    },
                                                    marginTop: "-10px",
                                                }}
                                            />
                                        </Box>
                                    </Paper>
                                </Grid>
                                {/* cards de llenado, producción cilos, ays, ultima prueba */}
                                <Grid container spacing={2} size={12} sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%",
                                    padding: 2,
                                }}>
                                    {/* Llenado */}
                                    <Grid size={2}>
                                        <Paper elevation={3}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    padding: 1,
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    marginTop: 1,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: "12px",
                                                        color: "custom.blue2",
                                                        fontWeight: "bold",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    % LLENADO
                                                </Typography>

                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                            "center",
                                                        flexGrow: 1, // ocupa el espacio restante
                                                        width: "100%",
                                                    }}
                                                >
                                                    <Typography
                                                        variant="h4"
                                                        sx={{
                                                            color: "custom.icons",
                                                            fontWeight: "bold",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        {activeDiagnostic?.bottomHoleFillage
                                                            ? Math.round(
                                                                activeDiagnostic?.bottomHoleFillage
                                                            )
                                                            : 0}
                                                        %
                                                    </Typography>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                            "center",
                                                        flexGrow: 1, // ocupa el espacio restante
                                                        width: "100%",
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontWeight: "bold",
                                                            textAlign: "right",
                                                            fontSize: "10px",
                                                            width: "100%",
                                                        }}
                                                    >
                                                        {activeDiagnostic?.ept
                                                            ? Math.round(
                                                                activeDiagnostic?.ept
                                                            )
                                                            : 0} in 
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Paper>
                                    </Grid>
                                    {/* Producción Carta */}
                                    <Grid size={2}>
                                        <Paper elevation={3}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    padding: 1,
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    marginTop: 1,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: "12px",
                                                        color: "custom.blue2",
                                                        fontWeight: "bold",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    BBPD (Carta)
                                                </Typography>

                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                            "center",
                                                        flexGrow: 1, // ocupa el espacio restante
                                                        width: "100%",
                                                    }}
                                                >
                                                    <Typography
                                                        variant="h4"
                                                        sx={{
                                                            color: "custom.icons",
                                                            fontWeight: "bold",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        {activeDiagnostic?.adjustProduction
                                                            ? Math.round(
                                                                activeDiagnostic?.adjustProduction
                                                            )
                                                            : 0}                                                
                                                    </Typography>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                            "center",
                                                        flexGrow: 1, // ocupa el espacio restante
                                                        width: "100%",
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontWeight: "bold",
                                                            textAlign: "right",
                                                            fontSize: "10px",
                                                            width: "100%",
                                                        }}
                                                    >
                                                        Eficiencia 100%
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Paper>
                                    </Grid>
                                    {/* AYS */}
                                    <Grid size={2}>
                                        <Paper elevation={3}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    padding: 0.75,
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    marginTop: 0.5,
                                                    gap: 0.5,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: "12px",
                                                        color: "custom.blue2",
                                                        fontWeight: "bold",
                                                        textAlign: "center",
                                                        marginBottom: 0.25,
                                                    }}
                                                >
                                                    % AyS
                                                </Typography>
                                                <Grid container spacing={1} size={12}>
                                                    <Grid size={8}>
                                                        <Typography sx={{ lineHeight: 1.2, fontWeight: "600", color: "custom.blue2" }}>Último: </Typography>
                                                        <Typography variant="caption" sx={{ fontSize: "0.7rem", lineHeight: 1, marginTop: -0.1, display: "block" }}> {lastWaterTest?.samplingDate ? moment(lastWaterTest?.samplingDate).format("DD-MMM-YY") : ""} </Typography>
                                                    </Grid>
                                                    <Grid size={4}>
                                                        <Typography sx={{ lineHeight: 1.2, color: "custom.icons", fontWeight: "bold"}}> {lastWaterTest?.totalWaterPercentage ? Math.round(lastWaterTest?.totalWaterPercentage) : 0}% </Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid container spacing={1} size={12}>
                                                    <Grid size={8}>
                                                        <Typography sx={{ lineHeight: 1.2, fontWeight: "600", color: "custom.blue2" }}>Promedio : </Typography>
                                                        <Typography variant="caption" sx={{ fontSize: "0.7rem", lineHeight: 1, marginTop: -0.1, display: "block" }}> {averageWaterTestsLast5?.startDate ? moment(averageWaterTestsLast5?.startDate).format("DD-MMM") : ""} al {averageWaterTestsLast5?.endDate ? moment(averageWaterTestsLast5?.endDate).format("DD-MMM") : ""} </Typography>
                                                    </Grid>
                                                    <Grid size={4}>
                                                        <Tooltip 
                                                            title={
                                                                averageWaterTestsLast5 
                                                                    ? (
                                                                        <Box>
                                                                            <Typography variant="caption" sx={{ display: "block", marginBottom: 0.5 }}>
                                                                                Últimas 5 muestras
                                                                            </Typography>
                                                                            <Typography variant="caption" sx={{ display: "block" }}>
                                                                                Media: {Math.round(averageWaterTestsLast5.average)}%
                                                                            </Typography>
                                                                            <Typography variant="caption" sx={{ display: "block" }}>
                                                                                Desviación estándar: {Math.round(averageWaterTestsLast5.standardDeviation * 100) / 100}%
                                                                            </Typography>
                                                                        </Box>
                                                                    )
                                                                    : "Últimas 5 muestras"
                                                            }
                                                        >
                                                            <Typography sx={{ lineHeight: 1.2, color: "custom.icons", fontWeight: "bold"}}> {averageWaterTestsLast5 ? Math.round(averageWaterTestsLast5.average) : 0}% </Typography>
                                                        </Tooltip>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Paper>
                                    </Grid>
                                    {/* Ultima prueba */}
                                    <Grid size={2}>
                                        <Paper elevation={3}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    padding: 1,
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    marginTop: 1,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: "12px",
                                                        color: "custom.blue2",
                                                        fontWeight: "bold",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    ÚLTIMA PRUEBA
                                                </Typography>

                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                            "center",
                                                        flexGrow: 1, // ocupa el espacio restante
                                                        width: "100%",
                                                    }}
                                                >
                                                    <Typography
                                                        variant="h4"
                                                        sx={{
                                                            color: "custom.icons",
                                                            fontWeight: "bold",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        {lastProductionTest?.netProduction
                                                            ? Math.round(
                                                                lastProductionTest?.netProduction
                                                            )
                                                            : 0}
                                                        / {lastProductionTest?.grossProduction
                                                            ? Math.round(
                                                                lastProductionTest?.grossProduction
                                                            )
                                                            : 0}
                                                    </Typography>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                            "center",
                                                        flexGrow: 1, // ocupa el espacio restante
                                                        width: "100%",
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontWeight: "bold",
                                                            textAlign: "right",
                                                            fontSize: "10px",
                                                            width: "100%",
                                                        }}
                                                    >
                                                        {lastProductionTest?.testDate ? moment(lastProductionTest?.testDate).format("DD-MMM-YY") : ""} (
                                                            {lastProductionTest?.testCondition ? lastProductionTest?.testCondition : ""}
                                                        )
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Paper>
                                    </Grid>
                                    {/* Ciclos de Vapor */}
                                    <Grid size={2}>
                                        <Paper elevation={3}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    padding: 1,
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    marginTop: 1,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: "12px",
                                                        color: "custom.blue2",
                                                        fontWeight: "bold",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    CICLOS DE VAPOR
                                                </Typography>

                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                            "center",
                                                        flexGrow: 1, // ocupa el espacio restante
                                                        width: "100%",
                                                    }}
                                                >
                                                    <Typography
                                                        variant="h4"
                                                        sx={{
                                                            color: "custom.icons",
                                                            fontWeight: "bold",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        {activeDiagnostic?.cicleCount
                                                            ? Math.round(
                                                                activeDiagnostic?.cicleCount
                                                            )
                                                            : 0}
                                                    </Typography>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                            "center",
                                                        flexGrow: 1, // ocupa el espacio restante
                                                        width: "100%",
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontWeight: "bold",
                                                            textAlign: "right",
                                                            fontSize: "10px",
                                                            width: "100%",
                                                        }}
                                                    >
                                                        {activeDiagnostic?.lastLocationEventHistoryChangeDate ? moment(activeDiagnostic?.lastLocationEventHistoryChangeDate).format("DD-MMM-YY") : ""}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Paper>
                                    </Grid>
                                </Grid>

                                {/* Opciones de diagnostico */}
                                <Grid container spacing={2} size={12}>
                                    {/* Estatus Candidato y Condicion de Fondo */}
                                    <Grid size={5}>
                                        <Paper elevation={3}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    padding: 2,
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <Typography className="label-input">
                                                    ESTATUS CANDIDATO
                                                </Typography>
                                                <FormControl
                                                    fullWidth
                                                    size="small"
                                                    sx={{
                                                        padding: 0.45,
                                                    }}
                                                >
                                                    <Select
                                                        value={
                                                            activeDiagnostic?.candidateSate ||
                                                            ""
                                                        }
                                                        onChange={(e) =>
                                                            handleOnChangeValue(
                                                                e.target.value,
                                                                "candidateSate"
                                                            )
                                                        }
                                                        error={
                                                            !activeDiagnostic?.candidateSate ||
                                                            activeDiagnostic?.candidateSate.trim() ===
                                                            ""
                                                        }
                                                        sx={{
                                                            backgroundColor:
                                                                "#f0f0f0",
                                                            "& fieldset": {
                                                                border: "none",
                                                            },
                                                            "& .MuiSelect-icon":
                                                            {
                                                                color: "custom.blue2",
                                                            },

                                                            "& .MuiOutlinedInput-root":
                                                            {
                                                                padding: 0.5,
                                                            },
                                                            "& .MuiInputBase-input":
                                                            {
                                                                padding: 0.5,
                                                            },
                                                        }}
                                                    >
                                                        {status_candidato_listy.map(
                                                            (status) => (
                                                                <MenuItem
                                                                    key={
                                                                        status.id
                                                                    }
                                                                    value={
                                                                        status.id
                                                                    }
                                                                >
                                                                    {
                                                                        status.name
                                                                    }
                                                                </MenuItem>
                                                            )
                                                        )}
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                        </Paper>

                                        <Paper
                                            elevation={3}
                                            sx={{ marginTop: 2 }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    padding: 2,
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <Typography className="label-input">
                                                    CONDICIÓN DE FONDO
                                                </Typography>
                                                <FormControl
                                                    fullWidth
                                                    size="small"
                                                    sx={{
                                                        padding: 0.45,
                                                    }}
                                                >
                                                    <Select
                                                        value={
                                                            activeDiagnostic?.bottomHoleCondition ||
                                                            ""
                                                        }
                                                        onChange={(e) =>
                                                            handleOnChangeValue(
                                                                e.target.value,
                                                                "bottomHoleCondition"
                                                            )
                                                        }
                                                        error={
                                                            !activeDiagnostic?.bottomHoleCondition ||
                                                            activeDiagnostic?.bottomHoleCondition.trim() ===
                                                            ""
                                                        }
                                                        sx={{
                                                            backgroundColor:
                                                                "#f0f0f0",
                                                            "& fieldset": {
                                                                border: "none",
                                                            },
                                                            "& .MuiSelect-icon":
                                                            {
                                                                color: "custom.blue2",
                                                            },

                                                            "& .MuiOutlinedInput-root":
                                                            {
                                                                padding: 0.5,
                                                            },
                                                            "& .MuiInputBase-input":
                                                            {
                                                                padding: 0.5,
                                                            },
                                                        }}
                                                    >
                                                        {condicionFondoList.map(
                                                            (cond) => (
                                                                <MenuItem
                                                                    key={
                                                                        cond.id
                                                                    }
                                                                    value={
                                                                        cond.id
                                                                    }
                                                                >
                                                                    {cond.name}
                                                                </MenuItem>
                                                            )
                                                        )}
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                        </Paper>
                                    </Grid>
                                    {/* Nuevo Estado Tarea y Sub Condicion */}
                                    <Grid size={5}>
                                        <Paper elevation={3}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    padding: 2,
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <Typography className="label-input">
                                                    NUEVO ESTADO TAREA
                                                </Typography>
                                                <FormControl
                                                    fullWidth
                                                    size="small"
                                                    sx={{
                                                        padding: 0.45,
                                                    }}
                                                >
                                                    <Select
                                                        value={
                                                            activeDiagnostic?.newFieldActivityState ||
                                                            ""
                                                        }
                                                        onChange={(e) =>
                                                            handleOnChangeValue(
                                                                e.target.value,
                                                                "newFieldActivityState"
                                                            )
                                                        }
                                                        error={
                                                            !activeDiagnostic?.newFieldActivityState ||
                                                            activeDiagnostic?.newFieldActivityState.trim() ===
                                                            ""
                                                        }
                                                        sx={{
                                                            backgroundColor:
                                                                "#f0f0f0",
                                                            "& fieldset": {
                                                                border: "none",
                                                            },
                                                            "& .MuiSelect-icon":
                                                            {
                                                                color: "custom.blue2",
                                                            },

                                                            "& .MuiOutlinedInput-root":
                                                            {
                                                                padding: 0.5,
                                                            },
                                                            "& .MuiInputBase-input":
                                                            {
                                                                padding: 0.5,
                                                            },
                                                        }}
                                                    >
                                                        {taskStates.map(
                                                            (task) => (
                                                                <MenuItem
                                                                    key={
                                                                        task.id
                                                                    }
                                                                    value={
                                                                        task.id
                                                                    }
                                                                >
                                                                    {task.name}
                                                                </MenuItem>
                                                            )
                                                        )}
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                        </Paper>

                                        <Paper
                                            elevation={3}
                                            sx={{ marginTop: 2 }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    padding: 2,
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <Typography className="label-input">
                                                    SUB-CONDICIÓN
                                                </Typography>
                                                <FormControl
                                                    fullWidth
                                                    size="small"
                                                    disabled
                                                    sx={{
                                                        padding: 0.45,
                                                    }}
                                                >
                                                    <Select
                                                        value={
                                                            activeDiagnostic?.subBottomHoleCondition ||
                                                            ""
                                                        }
                                                        // onChange={(e) =>
                                                        //     handleOnChangeValue(
                                                        //         e.target.value,
                                                        //         "newFieldActivityState"
                                                        //     )
                                                        // }
                                                        error={
                                                            !activeDiagnostic?.newFieldActivityState ||
                                                            activeDiagnostic?.newFieldActivityState.trim() ===
                                                            ""
                                                        }
                                                        sx={{
                                                            backgroundColor:
                                                                "#f0f0f0",
                                                            "& fieldset": {
                                                                border: "none",
                                                            },
                                                            "& .MuiSelect-icon":
                                                            {
                                                                color: "custom.blue2",
                                                            },

                                                            "& .MuiOutlinedInput-root":
                                                            {
                                                                padding: 0.5,
                                                            },
                                                            "& .MuiInputBase-input":
                                                            {
                                                                padding: 0.5,
                                                            },
                                                        }}
                                                    >
                                                        <MenuItem
                                                            value={
                                                                activeDiagnostic?.subBottomHoleCondition
                                                            }
                                                        >
                                                            {
                                                                activeDiagnostic?.subBottomHoleCondition
                                                            }
                                                        </MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                        </Paper>
                                    </Grid>

                                    {/* % Llenado / RUN LIFE (etiquetas de pozo debajo de este bloque) */}
                                    <Grid size={2}>

                                        <Paper elevation={3}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    padding: 1,
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    marginTop: 1,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: "12px",
                                                        color: "custom.blue2",
                                                        fontWeight: "bold",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                   RUN LIFE (Carta Activa)
                                                </Typography>

                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                            "center",
                                                        flexGrow: 1, // ocupa el espacio restante
                                                        width: "100%",
                                                    }}
                                                >
                                                    <Typography
                                                        variant="h4"
                                                        sx={{
                                                            color: "custom.icons",
                                                            fontWeight: "bold",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        {activeDiagnostic?.runLife
                                                            ? Math.round(
                                                                activeDiagnostic?.runLife
                                                            )
                                                            : 0} dias                                                 
                                                    </Typography>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                            "center",
                                                        flexGrow: 1, // ocupa el espacio restante
                                                        width: "100%",
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontWeight: "bold",
                                                            textAlign: "right",
                                                            fontSize: "10px",
                                                            width: "100%",
                                                        }}
                                                    >
                                                        {activeDiagnostic?.lastSubSurfaceJobFinishedDate ? moment(activeDiagnostic?.lastSubSurfaceJobFinishedDate).format("DD-MMM-YY") : ""}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Paper>



                                    </Grid>

                                </Grid>

                                <Grid size={12} sx={{ mt: 1 }}>
                                    <Paper elevation={1} sx={{ px: 2, py: 1.25 }}>
                                        <Grid container spacing={1.5} columnSpacing={2}>
                                            {WELL_DIAGNOSTIC_TAGS.map((def) => (
                                                <Grid key={def.tagId} size={{ xs: 12, sm: 6 }} sx={{ px:2, borderLeft: "2px solid #e0e0e0" }}>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "space-between",
                                                            gap: 1,
                                                            flexWrap: "wrap",
                                                        }}
                                                    >
                                                        <Typography
                                                            className="label-input"
                                                            sx={{
                                                                fontSize: "11px",
                                                                flex: "1 1 auto",
                                                                minWidth: 0,
                                                            }}
                                                        >
                                                            {def.label.toUpperCase()}
                                                        </Typography>
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                flexShrink: 0,
                                                            }}
                                                        >
                                                            <Typography
                                                                sx={{
                                                                    fontSize: "14px",
                                                                    color: "custom.blue2",
                                                                    fontWeight: "bold",
                                                                    mr: 1.5,
                                                                }}
                                                            >
                                                                No
                                                            </Typography>
                                                            <FormControl>
                                                                <FormControlLabel
                                                                    label=""
                                                                    control={
                                                                        <Switch
                                                                            checked={
                                                                                locationTags?.some(
                                                                                    (t) =>
                                                                                        t.tagId ===
                                                                                        def.tagId
                                                                                ) ?? false
                                                                            }
                                                                            onChange={(e) =>
                                                                                handleWellTagToggle(
                                                                                    def.tagId,
                                                                                    e.target
                                                                                        .checked,
                                                                                    def.removeConfirmText
                                                                                )
                                                                            }
                                                                        />
                                                                    }
                                                                />
                                                            </FormControl>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: "14px",
                                                                    color: "custom.blue2",
                                                                    fontWeight: "bold",
                                                                    ml: 0.5,
                                                                }}
                                                            >
                                                                Si
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Paper>
                                </Grid>

                                {/* Requerimientos */}
                                <Grid size={6} sx={{ mb: 2 }}>
                                    <Paper elevation={3} sx={{ padding: 2 }}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                            }}
                                        >
                                            <Typography className="label-input">
                                                REQUERIMIENTOS DE OPTIMIZACIÓN
                                            </Typography>
                                            <IconButton
                                                size="small"
                                                color="primary"
                                                onClick={() => setShowQuickAddRequirement(true)}
                                                sx={{
                                                    backgroundColor: "custom.blue2",
                                                    color: "#fff",
                                                    "&:hover": {
                                                        backgroundColor: "custom.blue1",
                                                    },
                                                    width: "25px",
                                                    height: "25px",
                                                }}
                                            >
                                                <AddIcon fontSize="small" />
                                            </IconButton>
                                        </Box>
                                        {filterTypeOfActivity(activeDiagnostic?.optimizationActivitiesSelected||[],"Requirement")?.map(
                                            (opt, i) => (
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent:
                                                            "space-between",
                                                        backgroundColor:
                                                            "custom.grey1",
                                                        borderRadius: "10px",
                                                        padding: "5px 15px",
                                                        alignItems: "center",
                                                    }}
                                                    key={i}
                                                >
                                                    <Typography
                                                        sx={{
                                                            color: "custom.blue2",
                                                            fontSize: "12px",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {opt?.name.toUpperCase()}
                                                    </Typography>

                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems:
                                                                "center",
                                                            justifyContent:
                                                                "center",
                                                        }}
                                                    >
                                                        <Tooltip
                                                            title={
                                                                "Convertir en principal"
                                                            }
                                                        >
                                                            <IconButton
                                                                onClick={() =>
                                                                    handleConvertToMain(
                                                                        opt
                                                                    )
                                                                }
                                                            >
                                                                {opt?.main ? (
                                                                    <LooksOneIcon
                                                                        sx={{
                                                                            color: "custom.blue2",
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <PublishIcon
                                                                        sx={{
                                                                            color: "custom.blue2",
                                                                        }}
                                                                    />
                                                                )}
                                                            </IconButton>
                                                        </Tooltip>

                                                        {opt?.isWellWithMultiplesTDSEntries && (
                                                            <Tooltip title="Pozo con multiples entradas TDS">
                                                                <WarningIcon
                                                                    color="warning"
                                                                    fontSize="small"
                                                                />
                                                            </Tooltip>
                                                        )}
                                                        <IconButton
                                                            size="small"
                                                            color="error"
                                                            onClick={() =>
                                                                addRemoveOptimizationActivity(
                                                                    opt,
                                                                    false
                                                                )
                                                            }
                                                        >
                                                            <DeleteForeverIcon fontSize="medium" />
                                                        </IconButton>
                                                    </Box>
                                                </Box>
                                            )
                                        )}
                                        {activeDiagnostic
                                            ?.optimizationActivitiesSelected
                                            ?.length === 0 && (
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        padding: "5px 0px",
                                                        alignItems: "center",
                                                        fontSize: "14px",
                                                        color: "rgba(248, 6, 6, 0.4)",
                                                    }}
                                                >
                                                    Debe Seleccionar al menos una
                                                    opción de optimization o requerimientos de las
                                                    disponibles
                                                </Box>
                                            )}
                                    </Paper>
                                </Grid>
                                {/*  Opciones de optimizacion */}
                                <Grid size={6} sx={{ mb: 2 }}>
                                    <Paper elevation={3} sx={{ padding: 2 }}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                width: "100%",
                                            }}
                                        >
                                            <Typography className="label-input">
                                                OPCIONES DE OPTIMIZACIÓN
                                            </Typography>
                                            <IconButton
                                                onClick={() => setShowQuickAddOptimization(true)}
                                                sx={{
                                                    backgroundColor: "#03365e",
                                                    color: "#fff",
                                                    "&:hover": {
                                                        backgroundColor: "#129ED3",
                                                    },
                                                    width: "25px",
                                                    height: "25px",
                                                }}
                                                size="small"
                                            >
                                                <AddIcon fontSize="small"/>
                                            </IconButton>
                                        </Box>
                                        {filterTypeOfActivity(activeDiagnostic?.optimizationActivitiesSelected||[],"Optimization")?.map(
                                            (opt, i) => (
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent:
                                                            "space-between",
                                                        backgroundColor:
                                                            "custom.grey1",
                                                        borderRadius: "10px",
                                                        padding: "5px 15px",
                                                        alignItems: "center",
                                                    }}
                                                    key={i}
                                                >
                                                    <Typography
                                                        sx={{
                                                            color: "custom.blue2",
                                                            fontSize: "12px",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {opt?.name.toUpperCase()}
                                                    </Typography>

                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems:
                                                                "center",
                                                            justifyContent:
                                                                "center",
                                                        }}
                                                    >
                                                        <Tooltip
                                                            title={
                                                                "Convertir en principal"
                                                            }
                                                        >
                                                            <IconButton
                                                                onClick={() =>
                                                                    handleConvertToMain(
                                                                        opt
                                                                    )
                                                                }
                                                            >
                                                                {opt?.main ? (
                                                                    <LooksOneIcon
                                                                        sx={{
                                                                            color: "custom.blue2",
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <PublishIcon
                                                                        sx={{
                                                                            color: "custom.blue2",
                                                                        }}
                                                                    />
                                                                )}
                                                            </IconButton>
                                                        </Tooltip>

                                                        {opt?.isWellWithMultiplesTDSEntries && (
                                                            <Tooltip title="Pozo con multiples entradas TDS">
                                                                <WarningIcon
                                                                    color="warning"
                                                                    fontSize="small"
                                                                />
                                                            </Tooltip>
                                                        )}
                                                        <IconButton
                                                            size="small"
                                                            color="error"
                                                            onClick={() =>
                                                                addRemoveOptimizationActivity(
                                                                    opt,
                                                                    false
                                                                )
                                                            }
                                                        >
                                                            <DeleteForeverIcon fontSize="medium" />
                                                        </IconButton>
                                                    </Box>
                                                </Box>
                                            )
                                        )}
                                        {activeDiagnostic
                                            ?.optimizationActivitiesSelected
                                            ?.length === 0 && (
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        padding: "5px 0px",
                                                        alignItems: "center",
                                                        fontSize: "14px",
                                                        color: "rgba(248, 6, 6, 0.4)",
                                                    }}
                                                >
                                                    Debe Seleccionar al menos una
                                                    opción de optimization de las
                                                    disponibles
                                                </Box>
                                            )}
                                    </Paper>
                                </Grid>
                                <Grid size={6} sx={{ mb: 2 }}>
                                    <Paper elevation={3} sx={{ padding: 2 }}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            <Typography className="label-input">
                                                ADJUNTOS
                                            </Typography>
                                        </Box>
                                        {activeDiagnostic?.attachedFiles?.map(
                                            (opt, i) => {
                                                const dateOfAttached =
                                                    opt?.variables.find(
                                                        (file: any) =>
                                                            file.name ===
                                                            "attachedRelatedDate"
                                                    )?.value;

                                                return (
                                                    <Box
                                                        key={i}
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent:
                                                                "space-between",
                                                            backgroundColor:
                                                                "custom.grey1",
                                                            borderRadius:
                                                                "10px",
                                                            padding: "5px 15px",
                                                            alignItems:
                                                                "center",
                                                            mb: 1,
                                                        }}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                width: "50%",
                                                            }}
                                                        >
                                                            {opt?.type}
                                                        </Typography>
                                                        {dateOfAttached && (
                                                            <Typography className="date_attachment">
                                                                {` ${formatDate(
                                                                    dateOfAttached,
                                                                    "dd-MMM"
                                                                )}`}
                                                            </Typography>
                                                        )}

                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                alignItems:
                                                                    "center",
                                                                justifyContent:
                                                                    "center",
                                                            }}
                                                        >
                                                            <IconButton
                                                                size="small"
                                                                color="primary"
                                                                onClick={() =>
                                                                    handleShowFileModal(
                                                                        opt.id
                                                                    )
                                                                }
                                                            >
                                                                <VrpanoIcon
                                                                    fontSize="medium"
                                                                    sx={{
                                                                        color: "custom.blue2",
                                                                    }}
                                                                />
                                                            </IconButton>
                                                            <IconButton
                                                                size="small"
                                                                color={"error"}
                                                                onClick={() =>
                                                                    handleAddRemoveAttachment(
                                                                        opt
                                                                    )
                                                                }
                                                            >
                                                                <DeleteForeverIcon fontSize="medium" />
                                                            </IconButton>
                                                        </Box>
                                                    </Box>
                                                );
                                            }
                                        )}
                                        {activeDiagnostic?.attachedFiles
                                            ?.length === 0 && (
                                                <Grid
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        padding: "5px 0px",
                                                        alignItems: "center",
                                                        fontSize: "14px",
                                                        color: "rgba(248, 6, 6, 0.4)",
                                                    }}
                                                >
                                                    No tiene soporte adjunto
                                                </Grid>
                                            )}
                                    </Paper>
                                </Grid>

                            </>
                        )}

                        {showVariables === "variables" && (
                            <Grid size={12}>
                                <Box className="table-container">
                                    <ModalVariables
                                        sortDyns={sortDyns}
                                        open={undefined}
                                        onClose={undefined}
                                        showAsModal={false}
                                    />
                                </Box>
                            </Grid>
                        )}
                        {showVariables === "optimizationOptions" && (
                            <Grid size={12}>
                                <Box className="table-container">
                                    <OptimizationActivities
                                        originFieldActivityIdFromDiagnostic={
                                            activeDiagnostic
                                                ?.originFieldActivityIds[0] ||
                                            ""
                                        }
                                        addRemoveOptimizationActivity={
                                            addRemoveOptimizationActivity
                                        }
                                        handleConvertToMain={
                                            handleConvertToMain
                                        }
                                        activeDiagnostic={activeDiagnostic}
                                    />
                                </Box>
                            </Grid>
                        )}
                        {showVariables === "requirements" && (
                            <Grid size={12} sx={{ paddingInline: 2 }}>
                                <Box className="table-container">
                                    <Requerimientos
                                        originFieldActivityIdFromDiagnostic={
                                            activeDiagnostic
                                                ?.originFieldActivityIds[0] ||
                                            ""
                                        }
                                        addRemoveOptimizationActivity={
                                            addRemoveOptimizationActivity
                                        }
                                        handleConvertToMain={
                                            handleConvertToMain
                                        }
                                        activeDiagnostic={activeDiagnostic}
                                    />
                                </Box>
                            </Grid>
                        )}
                        {showVariables === "trabajosSubsuelo" && (
                            <Grid sx={{ paddingInline: 2, width: "100%", padding: 2 }}>
                                <SubSurfaceJobs
                                    dataToTable={subSurfaceDataTable}
                                    setdataToTable={setSubSurfaceDataTable}
                                    filteredData={[]}
                                    filters={[]}
                                />
                            </Grid>
                        )}
                        {showVariables === "muestrasAyS" && (
                            <Grid size={12} sx={{ paddingInline: 2 }}>
                                <WaterTest
                                    filteredData={[]}
                                    filters={[]}
                                />
                            </Grid>
                        )}
                        {showVariables === "filesManager" && (
                            <FileAttachment
                                originActivityId={
                                    activeDiagnostic?.originFieldActivityIds[0]
                                }
                                addRemoveAttachment={handleAddRemoveAttachment}
                                activeDiagnostic={activeDiagnostic}
                            />
                        )}
                        {showVariables === "steamInjection" && (
                            <Grid sx={{ paddingInline: 2, width: "100%", padding: 2 }}>
                                <SteamModule />
                            </Grid>
                        )}
                        {showVariables === "productionTest" && (
                            <Grid sx={{ paddingInline: 2, width: "100%", padding: 2 }}>
                                <ProductionModule />
                            </Grid>
                        )}
                    </Grid>
                </Box>
                </Box>
            </Modal>
            <QuickAddOptimizationModal
                open={showQuickAddOptimization}
                onClose={() => setShowQuickAddOptimization(false)}
                originFieldActivityId={
                    activeDiagnostic?.originFieldActivityIds[0] || ""
                }
                activeDiagnostic={activeDiagnostic}
                addRemoveOptimizationActivity={addRemoveOptimizationActivity}
                onActivityCreated={handleActivityCreated}
            />
            <QuickAddRequirementModal
                open={showQuickAddRequirement}
                onClose={() => setShowQuickAddRequirement(false)}
                originFieldActivityId={
                    activeDiagnostic?.originFieldActivityIds[0] || ""
                }
                activeDiagnostic={activeDiagnostic}
                addRemoveOptimizationActivity={addRemoveOptimizationActivity}
                onRequirementCreated={handleRequirementCreated}
            />
        </>
    );
}